import cx from 'classnames';
import { t } from 'i18next';
import { FC, MouseEventHandler, useMemo } from 'react';
import { useLocation } from 'react-router';
import { stripPathLocale } from '../../common/localeShared';
import { useBrowserPlatform } from '../scripts/hooks/useBrowserPlatform';

type TDownloadButtonProps = {
  label?: string;
  style?: any;
  className?: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
};

export const DownloadButton: FC<TDownloadButtonProps> = (props) => {
  const location = useLocation();
  const platform = useBrowserPlatform();
  const platformIcon = useMemo(() => {
    if (platform === 'mac') {
      return 'fa-apple';
    } else if (platform === 'linux') {
      return 'fa-linux';
    } else {
      return 'fa-windows';
    }
  }, [platform]);

  if (stripPathLocale(location.pathname) === '/addon') {
    return null;
  }

  return (
    <button
      style={props.style}
      className={cx('slds-button slds-button--raiderio-gradient', props.className)}
      onClick={props.onClick}
    >
      <i className={cx('slds-m-right--x-small fa-brands', platformIcon)} />
      {props.label ||t('nav:main.download-client-and-addon')}
    </button>
  );
};
